<template>
    <h3 class="m-heading-bg">
        <span class="m-heading-bg-inner">{{ title }}</span>
    </h3>
</template>

<script>
    export default {
        props: {
            /**
             * 見出しにするテキスト
             */
            title: {
                type: String,
                required: true
            },
        }
    }
</script>
<style scoped lang="scss">
@use "../../../scss/v2/base/variables";
@use "../../../scss/v2/modules/heading";
    $grid-base: 4.27vw; // 375px幅に対して16px
    $grid-consistent: $grid-base * 0.5;// 375px幅に対して8px
    .m-heading-bg {
        padding: $grid-consistent;
        background: transparent;
        &-inner {
            display: block;
            color: variables.$color-pictlink-black-50;
            padding: 6px 16px 4px; //実機だと上下中央にならないため微調整
            background: variables.$color-pictlink-fog-15;
        }
    }
</style>
